const getProductByIDQuery = /* GraphQL */ `
  query getProductByID($id: ID!) {
    product(id: $id) {
      id
      handle
      availableForSale
      title
      productType
      descriptionHtml
      labIdentifier: metafield(namespace: "custom", key: "lab_identifier") {
        value
        key
      }
      isExpress: metafield(namespace: "custom", key: "is_express") {
        value
        key
      }
      featuredImage: images(first: 1) {
        edges {
          node {
            originalSrc
            altText
            width
            height
          }
        }
      }
    }
  }
`

export default getProductByIDQuery
